import React from "react";
import { CrystalContainerProps } from "@/types/laser-engraving";
import {
  TRANSMISSION_MATERIAL_ENHANCEMENTS,
  getCrystalModelPath,
} from "@/lib/laser-physics";
import { GLTFCrystalModel, CubeCrystalModel } from "./CrystalModel";

/**
 * 水晶容器组件
 *
 * 负责渲染水晶容器，支持立方体几何体和GLB水晶模型，使用 MeshTransmissionMaterial
 * 提供真实的水晶光学效果，包括透射、折射、色散等物理特性
 *
 * 特性：
 * - 支持立方体几何体和多种GLB水晶模型
 * - 基于真实石英水晶物理参数
 * - 支持完整的光学效果配置
 * - 优化的渲染性能
 * - 阴影投射和接收
 */
export const CrystalContainer = React.memo<CrystalContainerProps>(
  ({
    position = [0, 0, 0],
    rotation = [0, 0, 0],
    scale = 1,
    shellConfig,
    castShadow = true,
    receiveShadow = true,
  }) => {
    // 根据模型类型决定渲染方式
    const modelPath = getCrystalModelPath(shellConfig.modelType);

    // 如果是GLB模型，使用GLTFCrystalModel组件
    if (modelPath) {
      return (
        <GLTFCrystalModel
          modelPath={modelPath}
          position={position}
          rotation={rotation}
          scale={scale}
          shellConfig={shellConfig}
          castShadow={castShadow}
          receiveShadow={receiveShadow}
        />
      );
    }

    // 默认情况：使用立方体水晶模型组件
    return (
      <CubeCrystalModel
        position={position}
        rotation={rotation}
        scale={scale}
        shellConfig={shellConfig}
        castShadow={castShadow}
        receiveShadow={receiveShadow}
      />
    );
  },
);

CrystalContainer.displayName = "CrystalContainer";

export default CrystalContainer;
